import { Box, Dialog, Pagination, styled, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, useMediaQuery, Backdrop, CircularProgress } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import { CombinationDialog } from "./CombinationDialog";
import { constantsMsg } from "./constantsEU";
import { MsgContext } from "../../App";
import { API } from "./constantsFront";
import axios from "axios";
import * as React from "react";

/**
 * searchResultData: {
    id: 0
    , enumber: null
    , foodCategory: null
    , foodCategoryNumber: null
    , INSnumber: null
    , additiveNameEN: null
    , additiveNameJP: null
    , nationalRegulations: null
    , maximumValue: null
    , footnote: null
    , groupFootnote: null
    , constraintException: null
    , group: null
 * }
 * 
 * @param {searchResultData} param0 
 * @returns 
 */

export const FoodAdditiveSearchResultTable = ({ searchResultData }) => {
  //*********************************************************************************************
  // 定数定義
  //*********************************************************************************************
  const [tablePage, setTablePage] = useState(1); // 表示中のページ番号
  const recordCount = 5; // テーブルに表示する行数
  const isMobile = useMediaQuery('(max-width: 1000px)'); // SP表示用境界値
  const [openModal, setOpenModal] = useState(false); // 組合せモーダル管理
  const matchTxt = "@link@"; // リンク変換前の文字列
  const { msg, setMsg } = useContext(MsgContext); // エラーメッセージ
  const [isLoading, setIsLoading] = useState(false); // Loading
  let body = { authKey: API.API_KEY }; // POSTデータ
  let combinationList = []; // 組合せリスト

  // ヘッダー定義
  const headCells = [
    { id: 0, column: 'enumber', label: 'Eナンバー', }
    , { id: 1, column: 'foodCategoryNumber', label: '食品カテゴリー\n番号', }
    , { id: 2, column: 'foodCategory', label: '食品カテゴリー', }
    , { id: 3, column: 'INSnumber', label: 'INS番号', }
    , { id: 4, column: 'additiveNameEN', label: '食品添加物名(EN)', }
    , { id: 5, column: 'additiveNameJP', label: '食品添加物名(JP)', }
    , { id: 6, column: 'nationalRegulations', label: '日本の\n規制', }
    , { id: 7, column: 'maximumValue', label: '最大値\n(適宜mg/lまたはmg/kg)', }
    , { id: 8, column: 'footnote', label: '脚注', }
    , { id: 9, column: 'groupFootnote', label: 'グループの脚注', }
    , { id: 10, column: 'constraintException', label: '制約/例外', }
  ];

  // ボディー定義
  const [sortState, setSortState] = useState({
    rows: [searchResultData], //配列
    order: "desc", // 降順ソート中("desc") or 昇順ソート中("asc")
    key: headCells[0].column // ソート中の列名
  });

  // 組み合わせテーブル
  const [combinationRows, setCombinationRows] = useState([{
    id: 0
    , group: null
    , groupName: null
    , maximumValue: null
    , footnote: null
    , constraintException: null
  }]);

  //*********************************************************************************************
  // 関数定義
  //*********************************************************************************************

  /*
    ソート機能
  */
  function handleClickSortColumn(column) {
    // 選択中の列をもう一回クリックしたときは降順/昇順を切り替える。
    // 選択中ではない列をクリックしたときはまず降順でソートする。
    const isDesc = column === sortState.key && sortState.order === "desc";
    const nextOrder = isDesc ? "asc" : "desc";
    const sortRule = { asc: [1, -1], desc: [-1, 1] };
    const sortedRows = sortState.rows.slice().sort((a, b) => {
      if (a[`${column}`] > b[`${column}`]) {
        return sortRule[nextOrder][0];
      } else if (a[column] < b[column]) {
        return sortRule[nextOrder][1];
      } else {
        return 0;
      }
    });

    setSortState({
      rows: sortedRows,
      order: nextOrder,
      key: column
    });
  }

  /*
    食品カテゴリー番号、グループから組合せリストを取得
  */
  async function getCombinationList(foodCategoryNumber, group, enumber) {

    let res;

    // 添加物リストを取得
    res = await axios.post("/m_eu_additive_list/select", body);
    const additiveList = res.data.dataList;

    // 脚注リストを取得
    res = await axios.post("/m_eu_footnote/select", body);
    const footnoteList = res.data.dataList;

    if (foodCategoryNumber == "" || group == "") {
      return []
    }

    body.selectMode = "modal"
    body.foodCategoryNumber = foodCategoryNumber;
    body.group = group;
    res = await axios.post("/m_eu_combination/select", body);
    let combinationList = res.data.dataList;

    let combinationRowsData = [];

    if (combinationList.length == 0) {
      return [];
    }

    // 添加物テーブルを作成
    var footnote = ""
    for (let i in combinationList) {
      footnote = getFootnote(footnoteList, combinationList[i].footnote_number) || ''
      footnote = getAdditiveFootnote(footnote, additiveList, enumber)
      combinationRowsData.push({
        id: i
        , group: combinationList[i].group || ''
        , groupName: combinationList[i].group_name || ''
        , maximumValue: combinationList[i].maximum_value || ''
        , footnote: footnote
        , constraintException: combinationList[i].constraint_exception || ''
      });
    };

    setIsLoading(false);

    return combinationRowsData;
  }

  /*
    脚注を取得
  */
  function getFootnote(footnoteList, footnote) {
    const strAt = "@";

    // 空、もしくは、"@"がなければreturn
    if (footnote == undefined || footnote.indexOf(strAt) == -1) {
      return footnote
    };

    // 脚注番号を取り出すために"@"で切り分ける
    let matchFootnoteArr = footnote.split(strAt);

    // null回避
    if (matchFootnoteArr.length == 0) {
      return footnote
    }

    // 切り分けた脚注番号でループ
    for (let i in matchFootnoteArr) {
      // 脚注を検索
      for (let j in footnoteList) {
        if (footnoteList[j].footnote_number == matchFootnoteArr[i]) {
          // 脚注番号と脚注内容を置き換える
          footnote = footnote.replace(strAt + matchFootnoteArr[i] + strAt, footnoteList[j].footnote);
          break;
        };
      };
    }

    return footnote;
  };

  /*
    添加物一覧内の脚注を取得
  */
  function getAdditiveFootnote(footnote, additiveList, enumber) {
    const strLink = "@link@"

    // 添加物一覧内の脚注を検索
    for (let i in additiveList) {
      if (additiveList[i].e_number == enumber) {
        if (additiveList[i].remarks) {
          // 脚注を追加する
          if (footnote.indexOf(strLink) == -1) {
            footnote = footnote + '\n' + additiveList[i].remarks
          }
          else {
            footnote = footnote.replace(strLink, additiveList[i].remarks + '\n' + strLink)
          };
          break;
        };
      };
    };

    return footnote
  }  

  /*
    改行コードを改行タグに変換し、リンク変換用文字列を消す
  */
  function linkConvart(d) {
    // リンク用文字を消す
    let text = d.footnote.replace(matchTxt, "");
    
    // "#"をカッコに変換
    text = text.replace("#", "（");
    text = text.replace("#", "）");
    
    if (text){
      return <span><p>{brTagConvart(text)}</p><a style={{ cursor: "pointer" }} onClick={() => onClickFootnoteHandler(d)} >{constantsMsg.STR_MODAL_LINK}</a></span>
    }
    else {
      return <span><a style={{ cursor: "pointer" }} onClick={() => onClickFootnoteHandler(d)} >{constantsMsg.STR_MODAL_LINK}</a></span>
    }
  }

  /*
    改行コードを改行タグに変換
  */
  function brTagConvart(text) {
    // "#"をカッコに変換
    text = text.replace("#", "（");
    text = text.replace("#", "）");
    return text.split('\n').map(t => (<>{t}<br /></>))
  }

  /*
    表示中のページ数を取得
  */
  function getStartIdx(tablePage, recordCount, rows) {
    if (rows.length == 0) {
      return 1
    }

    // 配列が初期化されている場合は1を返す
    if (rows.length == 1) {
      if (rows[0].enumber == null) {
        return 1
      }
    }

    let page = tablePage * recordCount - recordCount
    return page
  }

  //*********************************************************************************************
  // 更新処理
  //*********************************************************************************************

  useEffect(() => {
    setSortState({
      rows: searchResultData,
      order: "desc",
      key: headCells[0].column
    });
    setTablePage(1);
  }, [searchResultData]);

  //*********************************************************************************************
  // ハンドラ
  //*********************************************************************************************

  // 表示中のページ
  const CustomizedLabel = ({ from, to, count, page }) => {
    return `全${count !== -1 ? count : `more than ${to}`}件中 ${from}-${to}`;
  };

  // ページ切り替え
  const handleChange = (event, index) => {
    setTablePage(index);
  }

  // モーダルを開く(脚注の固定文字をクリック)
  const onClickFootnoteHandler = async (d) => {
    try {
      // Loading表示
      setIsLoading(true);
      
      // リストを取得
      combinationList = await getCombinationList(d.foodCategoryNumber, d.group, d.enumber);
      setCombinationRows(combinationList)
      
      // モーダル表示
      setOpenModal(true);
    } catch (err) {
      return setMsg(constantsMsg.STR_ERROR);
    } finally {
      // Loading非表示
      setIsLoading(false);
    }
  };

  // ダイアログを閉じる
  const closeModalHandler = () => {
    setOpenModal(false);
  };

  //*********************************************************************************************
  // styledComponents
  //*********************************************************************************************
  const styles = {
    grid: {
      display: "flex",
      padding: "20px",
      marginTop: isMobile ? "50px" : "none",

      // // 表示中のページ
      ".MuiToolbar-root-MuiTablePagination-toolbar .MuiTablePagination-actions": {
        display: "flex"
      },
      // 「表示中のページ」の左にあるスペース(非表示にする)
      ".css-levciy-MuiTablePagination-displayedRows": {
        position: "absolute",
        marginTop: isMobile ? "-30px" : "5px"
        // marginTop: `${displayedRowsMargin}px`
      },
      // // ぺージャー
      "MuiTablePagination-root": {
        width: "-webkit-fill-available"
      },
      ".MuiToolbar-root MuiToolbar-gutters MuiToolbar-regular MuiTablePagination-toolbar MuiToolbar-root-MuiTablePagination-toolbar": {
        width: "100%",
        display: "inline-grid"
      },
      "MuiToolbar-root MuiToolbar-gutters MuiToolbar-regular MuiTablePagination-toolbar MuiToolbar-root-MuiTablePagination-toolbar": {
        width: "-webkit-fill-available"
      },
      ".MuiTablePagination-root": {
        flexFlow: "column"
      },
      ".MuiTablePagination-toolbar": {
        display: "contents"
      },
      // ".MuiSvgIcon-root": {
      //   backgroundColor: "none"
      // }
    },
  };

  //*********************************************************************************************
  // コンポーネント
  //*********************************************************************************************

  return (
    
    <Box position="relative" justifyContent="space-evenly">
      
      <TablePagination
        component="div"
        count={searchResultData.length}
        rowsPerPage={recordCount}
        labelDisplayedRows={CustomizedLabel}
        Icon
        page={tablePage - 1}
        rowsPerPageOptions={[]}
        showFirstButton
        showLastButton
        onPageChange={handleChange}
        size={isMobile ? "small" : "midiam"}
        sx={styles.grid}

        ActionsComponent={(props) => (
          <Pagination
            siblingCount={ isMobile? 1 : undefined}
            count={Math.ceil(props.count / recordCount)}
            page={tablePage}
            rowsPerPage={props.rowsPerPage}
            showFirstButton
            showLastButton
            className={props.className}
            onChange={props.onPageChange}
            sx={{ right: 0, overflowX: isMobile ? "hidden" : undefined }}
            size={isMobile ? "small" : "midiam"}
          />
        )}
      />
      
      {/* Loading */}
      <Backdrop open={isLoading}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <CircularProgress />
      </Backdrop>
      
      <TableContainer>
        <Table >
          {/* 添加物検索結果テーブル（ヘッダー） */}
          <TableHead>
            <TableRow>
              {/* Eナンバー */}
              <CtableHeader sx={{ minWidth: "100px" }} key={`table-header-col-${headCells[0].id}`} sortDirection={sortState.key === headCells[0].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[0].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[0].column)}>
                  {headCells[0].label}
                </TableSortLabel>
              </CtableHeader>

              {/* 食品カテゴリー番号 */}
              <CtableHeader sx={{ minWidth: "125px" }} key={`table-header-col-${headCells[1].id}`} sortDirection={sortState.key === headCells[1].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[1].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[1].column)}>
                  {headCells[1].label}
                </TableSortLabel>
              </CtableHeader>
              
              {/* 食品カテゴリー */}
              <CtableHeader sx={{ minWidth: "250px" }} key={`table-header-col-${headCells[2].id}`} sortDirection={sortState.key === headCells[2].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[2].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[2].column)}>
                  {headCells[2].label}
                </TableSortLabel>
              </CtableHeader>

              {/* INS番号 */}
              <CtableHeader sx={{ minWidth: "90px" }} key={`table-header-col-${headCells[3].id}`} sortDirection={sortState.key === headCells[3].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[3].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[3].column)}>
                  {headCells[3].label}
                </TableSortLabel>
              </CtableHeader>

              {/* 食品添加物名(EN) */}
              <CtableHeader sx={{ minWidth: "150px" }} key={`table-header-col-${headCells[4].id}`} sortDirection={sortState.key === headCells[4].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[4].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[4].column)}>
                  {headCells[4].label}
                </TableSortLabel>
              </CtableHeader>

              {/* 食品添加物名(JP) */}
              <CtableHeader sx={{ minWidth: "150px" }} key={`table-header-col-${headCells[5].id}`} sortDirection={sortState.key === headCells[5].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[5].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[5].column)}>
                  {headCells[5].label}
                </TableSortLabel>
              </CtableHeader>

              {/* 日本の規制 */}
              <CtableHeader sx={{ minWidth: "80px" }} key={`table-header-col-${headCells[6].id}`} sortDirection={sortState.key === headCells[6].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[6].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[6].column)}>
                  {brTagConvart(headCells[6].label)}
                </TableSortLabel>
              </CtableHeader>

              {/* 最大値(適宜mg/lまたはmg/kg) */}
              <CtableHeader sx={{ minWidth: "180px" }} key={`table-header-col-${headCells[7].id}`} sortDirection={sortState.key === headCells[7].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[7].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[7].column)}>
                  {brTagConvart(headCells[7].label)}
                </TableSortLabel>
              </CtableHeader>
              
              {/* 脚注 */}
              <CtableHeader sx={{ minWidth: "250px" }} key={`table-header-col-${headCells[8].id}`} sortDirection={sortState.key === headCells[8].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[8].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[8].column)}>
                  {headCells[8].label}
                </TableSortLabel>
              </CtableHeader>

              {/* グループの脚注 */}
              <CtableHeader sx={{ minWidth: "250px" }} key={`table-header-col-${headCells[9].id}`} sortDirection={sortState.key === headCells[9].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[9].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[9].column)}>
                  {headCells[9].label}
                </TableSortLabel>
              </CtableHeader>

              {/* 制約/例外 */}
              <CtableHeader sx={{ minWidth: "250px" }} key={`table-header-col-${headCells[10].id}`} sortDirection={sortState.key === headCells[10].column ? sortState.order : false}>
                <TableSortLabel active={sortState.key === headCells[10].column} direction={sortState.order} onClick={() => handleClickSortColumn(headCells[10].column)}>
                  {headCells[10].label}
                </TableSortLabel>
              </CtableHeader>
            </TableRow>
          </TableHead>

          {/* 添加物検索結果テーブル（ボディー）*/}
          <TableBody>
            {(recordCount > 0 ? sortState.rows.slice(getStartIdx(tablePage, recordCount, sortState.rows), tablePage * recordCount) : sortState.rows).map((d, i, a) => {
              return (
                <TableRow hover key={`table-row-row-${d.id}`}>
                  {/* Eナンバー */}
                  <CtableCell sx={{ display: "table-cell", textAlign: "center" }} key={`table-row-${d.id}-col-${headCells[0].id}`}>
                    {d.enumber}
                  </CtableCell>
                  
                  {/* 食品カテゴリーナンバー */}
                  <CtableCell sx={{ display: "table-cell", textAlign: "center" }} key={`table-row-${d.id}-col-${headCells[1].id}`}>
                    {d.foodCategoryNumber}
                  </CtableCell>

                  {/* 食品カテゴリー */}
                  <CtableCell sx={{ textAlign: "center", }} key={`table-row-${d.id}-col-${headCells[2].id}`}>
                    {d.foodCategory}
                  </CtableCell>

                  {/* INS番号 */}
                  <CtableCell sx={{ display: "table-cell", textAlign: "center" }} key={`table-row-${d.id}-col-${headCells[3].id}`}>
                    {d.INSnumber}
                  </CtableCell>

                  {/* 食品添加物名(EN) */}
                  <CtableCell sx={{ display: "table-cell", textAlign: "center" }} key={`table-row-${d.id}-col-${headCells[4].id}`}>
                    {d.additiveNameEN}
                  </CtableCell>

                  {/* 食品添加物名(JP) */}
                  <CtableCell sx={{ display: "table-cell", textAlign: "center" }} key={`table-row-${d.id}-col-${headCells[5].id}`}>
                    {d.additiveNameJP}
                  </CtableCell>

                  {/* 日本の規制 */}
                  <CtableCell sx={{ display: "table-cell", minWidth: isMobile ? "50px" : "auto", textAlign: "center" }} key={`table-row-${d.id}-col-${headCells[6].id}`}>
                    {d.nationalRegulations}
                  </CtableCell>

                  {/* 最大値(適宜mg/lまたはmg/kg) */}
                  <CtableCell sx={{ wordBreak: "keep-all" }} key={`table-row-${d.id}-col-${headCells[7].id}`}>
                    {brTagConvart(d.maximumValue)}
                  </CtableCell>

                  {/* 脚注（組合せデータがあればリンク化） */}
                  <CtableCell sx={{ wordBreak: "keep-all" }} key={`table-row-${d.id}-col-${headCells[8].id}`}>
                    {d.footnote.indexOf(matchTxt) != -1 ?
                      linkConvart(d)
                      :
                      <p>{brTagConvart(d.footnote)}</p>
                    }
                  </CtableCell>

                  {/* グループの脚注 */}
                  <CtableCell sx={{ wordBreak: "keep-all" }} key={`table-row-${d.id}-col-${headCells[9].id}`}>
                    {brTagConvart(d.groupFootnote)}
                  </CtableCell>

                  {/* 制約/例外 */}
                  <CtableCell sx={{ wordBreak: "keep-all" }} key={`table-row-${d.id}-col-${headCells[10].id}`}>
                    {brTagConvart(d.constraintException)}
                  </CtableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* 組み合わせダイアログ */}
      <Dialog
        fullWidth
        maxWidth="md"
        height="md"
        open={openModal}
        onClose={closeModalHandler}
        aria-labelledby="responsive-dialog-title"
      >
        <Box sx={{ p: 4 }}>
          <div style={{ textAlign: "center", color: "#FFFFFF", backgroundColor: "#1B335E", paddingTop: "20px", paddingBottom: "20px" }}>{constantsMsg.STR_MODAL_TITLE}</div>
          <CombinationDialog combinationRows={combinationRows} />
          <div style={{ display: "flex", marginTop: "20px" }}>
            <input type="button" style={{ display: "block", width: "150px", margin: "auto" }} value="閉じる" class="buttonDefault modalClose graylBtn" onClick={closeModalHandler} />
          </div>
        </Box>
      </Dialog>
    </Box>
  );
}

// テーブルcss
const CtableHeader = styled(TableCell)(() => ({
  backgroundColor: "#EDEEF2",
  textAlign: 'center',
  fontSize: '12px',
  border: `1px solid #C7C7C7`,
  padding: `5px`,
  display: "table-cell",
}));

const CtableCell = styled(TableCell)(() => ({
  border: `1px solid #C7C7C7`,
  padding: "5px",
}));
